import PropTypes from 'prop-types';
import React, {  } from 'react';
import 'scss/_connection.scss';
import ConnectionPage from './ConnectionPage';
import { useAppSelector } from '../../redux/store';

export default function Connection(props) {
  const token = useAppSelector(state => state.appState.token);

  return !token ? (
    <div className="fullscreenv1"><ConnectionPage /></div>
  ) : (
    props.children
  );
}

Connection.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
};
